module.exports = __webpack_public_path__ + "img/loading-square.b0fda8f8.gif";